import React from 'react';
import Footer from '../components/Footer';

/**
 * DocumentLayout - Clean layout for forms and policy documents
 * 
 * This layout provides a minimal structure without the main site navbar,
 * making pages print-friendly and professional for standalone documents.
 * 
 * Features:
 * - No Navbar (clean header area)
 * - Footer included (hidden in print via CSS)
 * - Proper spacing without fixed navbar compensation
 */
const DocumentLayout = ({ children }) => {
  return (
    <div className="document-layout min-h-screen flex flex-col">
      {/* Main Content */}
      <main className="flex-grow">
        {children}
      </main>
      
      {/* Footer - will be hidden in print via @media print */}
      <Footer />
    </div>
  );
};

export default DocumentLayout;
